<template>
  <div class="flex justify-end">
    <a class="inline-flex flex justify-center flex-row-reverse md:flex-row items-center py-2 cursor-pointer w-64 mx-auto md:mx-unset"
       @click="downloadPdf"
    >
      <p class="text-sm pl-2 md:pl-0">{{ $t('messages_nl.partials.letter.pdf.download') }}</p>
      <span

        class="flex w-16 md:w-20 md:justify-end"
      >
        <span
          v-if="loading"
          class="loader-bars loader-bars--size-lg ml-3 md:mr-3 ml-0"
        ></span>
        <img
          v-else
          :src="$asset('img/cancellation/download.svg')"
          :alt="$t('messages_nl.partials.letter.pdf.altImage')"
          class="md:ml-2"
          width="35"
          height="35"
          loading="lazy"
        >
      </span>
    </a>
    <adivare-alert
      v-if="clicked && showErrors"
      class="mt-20 z-10 max-w-xs w-full mx-auto left-0 md:left-unset right-0"
      :messages="$t('messages_nl.partials.letter.pdf.warning.text')"
      hoover
      pointer="up-middle"
      size="sm"
      show-icon
    />
  </div>
</template>

<script>
import client from "../../../axios-client";
import submitMixin from "../../mixins/submit-mixin";
import AdivareAlert from '../../../components/alert';
import { mapGetters } from 'vuex';

export default {
  name: "adivare-letter-download",
  mixins: [
    submitMixin,
  ],
  components: {
    AdivareAlert,
  },
  props: {
    downloadUrl: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      clicked: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      'showErrors',
    ]),
  },
  methods: {
    downloadPdf() {
      if (0 < this.$store.getters.getErrorCount || false === this.$store.getters.hasValidSignature) {
        this.$store.commit('showErrors', true);
        console.debug(`Errors: ${JSON.stringify(this.$store.getters.getFormFieldValidityStates)}`);
        this.timerClicked();
      } else {
        this.loading = true;
        const userLetterType = {
          ...this.$store.getters.getFormFields,
          [this.$store.getters.getIbanParameters.propertyName]: this.$store.getters.getIbanFormField,
          [this.$store.getters.getReasonToCancelParameters.propertyName]: this.$store.getters.getReasonToCancelFormField,
          additionalFields: this.$store.getters.getAdditionalFormFieldValues,
        };
        client
          .downloadPdf(
            this.$store.getters.cancellationId,
            { userLetterType }
          ).then(response => {
            location.assign(response.data.data.url);
            this.loading = false;
          }).catch(error => this.handleSubmitError(error))
      }
    },
    timerClicked() {
      this.clicked = true;
      setTimeout(() => {
        this.clicked = false;
      }, 6000);
    }
  }
}
</script>
